import Button from '$store/components/ui/Button.tsx'
import { useSignal } from '@preact/signals'
import { HTMLWidget, ImageWidget } from 'apps/admin/widgets.ts'
import Image from 'apps/website/components/Image.tsx'
import { Picture, Source } from 'apps/website/components/Picture.tsx'
import RenderHTML from 'site/components/ui/RenderHTML.tsx'

export interface CouponCardProps {
    /**
     * @title Imagens para desktop e mobile
     */
    images: { desktop: ImageWidget; mobile: ImageWidget }
    /**
     * @title Titulo
     * @format rich-text
     */
    title: HTMLWidget
    /**
     * @title Descrição
     */
    description: string
    /**
     * @title Link do Botão
     */
    selectLink?: 'Opção de Link' | 'Opção de Copiar'
    link?: string
    /**
     * @title Texto do cupom
     */
    coupon: string
    /**
     * @title Lista de restrições
     */
    restrictions: string[]
}

function CouponCard(props: CouponCardProps) {
  const { images, coupon, description, restrictions, title, selectLink, link} = props
    const copied = useSignal(false)

    const copy = () => {
        copied.value = true
        navigator.clipboard.writeText(coupon)
        setTimeout(() => {
            copied.value = false
        }, 10000)
    }

    return (
      <>
        <div class='bg-neutral-5 flex flex-col items-center w-[300px] overflow-hidden'>
            <Picture>
                <Source media='(max-width: 600px)' src={images.mobile} width={300} height={150} />
                <Source media='(min-width: 601px)' src={images.desktop} width={300} height={150} />
                <Image
                    class='w-full h-full object-cover sm:max-w-[300px] min-w-[265px]'
                    src={images.mobile}
                    alt='cupom cover'
                    decoding='async'
                    height={300}
                    width={150}
                />
            </Picture>
            <div class='px-6 pt-[25px] flex flex-col items-center'>
                <span class='text-center font-lato [&_strong]:font-extrabold text-sm [&_strong]:text-base text-neutral-0 h-[38px] leading-none whitespace-nowrap'>
                    <RenderHTML html={title} />
                </span>
                <span class='text-neutral-1 font-lato text-xs mt-1'>{description}</span>

                {selectLink === 'Opção de Link' ? (
                  <a
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    class="flex text-center items-center justify-center h-[40px] bg-primary-700 text-xs font-lato rounded-full font-bold text-white uppercase w-full mt-5"
                  >
                    Acessar
                  </a>
                ) : (
                  <div
                      class={`relative flex rounded-full border  w-[232px] h-[40px] justify-between items-center mt-6 box-content ${
                          copied.value === true ? 'border-success-700 ' : 'border-primary-700'
                      }`}
                  >
                      <span class='h-full pl-[15px] py-[12px] rounded-full w-full text-neutral-0 bg-white text-xs font-lato font-bold flex-grow'>
                          {coupon}
                      </span>
                        <Button
                          data-copied={copied.value}
                          onClick={copy}
                          class="flex text-center justify-center h-[40px] absolute top-0 -right-1 bg-primary-700 text-xs font-lato rounded-full font-bold text-white uppercase w-[76px] data-[copied='true']:bg-success-700 "
                                    >
                          {copied.value ? <span>Copiado</span> : <span>copiar</span>}
                        </Button>
                      
                  </div>
                )} 
                <ul class='text-xs font-lato text-neutral-1 flex flex-col items-center text-center mt-6 mb-[25px]'>
                    {restrictions.map((restriction) => <li>* {restriction}</li>)}
                </ul>
            </div>
        </div>
      </>
    )
}

export default CouponCard
